var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHybrid = function SvgHybrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-black)",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.067,
    d: "M7.578 6.227H1.415a.88.88 0 0 0-.88.88v3.081c0 .487.394.88.88.88h6.163a.88.88 0 0 0 .88-.88v-3.08a.88.88 0 0 0-.88-.88ZM2.293 6.227v-1.76a2.2 2.2 0 0 1 4.358-.44M20.77 15.633h-6.163a.88.88 0 0 0-.88.88v3.081c0 .486.394.88.88.88h6.162a.88.88 0 0 0 .88-.88v-3.08a.88.88 0 0 0-.88-.881Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-black)",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.067,
    d: "M15.484 15.633v-1.76a2.2 2.2 0 0 1 3.507-1.775"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-black)",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.067,
    d: "M19.926 15.633v-1.76a2.2 2.2 0 0 0-3.506-1.775M17.687.729l-12.125 21"
  })));
};
export default SvgHybrid;